import script from "./ProductList.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductList.vue?vue&type=script&lang=ts&setup=true"

import "./ProductList.vue?vue&type=style&index=0&id=409a21d6&lang=css"
import "./ProductList.vue?vue&type=style&index=1&id=409a21d6&lang=scss"
import "./ProductList.vue?vue&type=style&index=2&id=409a21d6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Arco\\Documents\\Git\\unifix\\unifix-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-409a21d6"]])

export default __exports__